import { AxiosError } from 'axios';
import { useState } from 'react';

import { BusinessInfoInterface } from '../../../models/dashboard/settings/business-info';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { businessInfoDataActions } from '../../../redux/slices/businessInfoDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';
import useGetExistingApiKeys from '../configuration/useGetExistingApiKeys';

const useBusinessInfo = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);
    const { getExistingApiKeys } = useGetExistingApiKeys();

    const onBusinessInfoError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onBusinessInfoSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<BusinessInfoInterface>) => {
        dispatch(businessInfoDataActions.setBusinessInfo(data));
        getExistingApiKeys(data?.isTestMode ?? false);
    };

    const businessInfo = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/get-company-info`,
            method: 'get',
        };

        return request(url, onBusinessInfoSuccess, setLoading, onBusinessInfoError);
    };

    return { businessInfo, loading };
};

export default useBusinessInfo;
